import tocbot from 'tocbot';

document.addEventListener('DOMContentLoaded', function () {
    const content = document.querySelector('#article-content, #section-8');
    if (content) {
        const headings = content.querySelectorAll('h2, h3, h4');
        headings.forEach(function (heading) {
            if (!heading.id) {
                const slug = heading.textContent
                    .trim()
                    .toLowerCase()
                    .replace(/\s+/g, '-')
                    .replace(/[^\w\-]+/g, '');
                heading.id = slug;
            }
        });
    }

    // Initialize Tocbot
    tocbot.init({
        tocSelector: ".toc",
        contentSelector: "#article-content, #section-8",
        headingSelector: "h2, h3, h4",
        hasInnerContainers: true,
        scrollSmooth: false,
        scrollSmoothDuration: 400,
        positionFixedSelector: ".toc-wrapper",
        positionFixedClass: "sticky-top",
        collapseDepth: 6,
        headingsOffset: 120,
        scrollSmoothOffset: -120,
    });
});
